import {BTCWalletAdapter} from "../lib/WalletAdapter";
import {UnisatAdapter} from "../lib/btc/UnisatAdapter";
import {XverseAdapter} from "../lib/btc/XverseAdapter";
import {LeatherAdapter} from "../lib/btc/LeatherAdapter";
import {useEffect, useState} from "react";
import {PhantomAdapter} from "../lib/btc/PhantomAdapter";

export const useBTCWallet = () => {

    const wallets: BTCWalletAdapter[] = [new UnisatAdapter(), new XverseAdapter(), new LeatherAdapter(),new PhantomAdapter()];
    const [installedWallets, setInstalledWallets] = useState<BTCWalletAdapter[]>([]);
    const [address, setAddress] = useState<string | null>(null);
    useEffect(() => {
        const getInstalled = async () => {
            const installed = await Promise.all(wallets.map(wallet => wallet.isInstalled().then(isInstalled => ({
                wallet,
                isInstalled
            }))));
            setInstalledWallets(installed.filter(({isInstalled}) => isInstalled).map(({wallet}) => wallet));
        };
        // console.log('getInstalled');
        getInstalled();
    }, []);

    const [wallet, chooseWallet] = useState<BTCWalletAdapter | null>(null);

    const onConnect = async () => {
        setAddress(await wallet!.connect());
    }
    useEffect(() => {

        if (!wallet) {
            setAddress(null)
        }
    }, [wallet]);

    return {
        installedWallets,
        wallets,
        chooseWallet,
        wallet,
        address,
        onConnect

    }

}